import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'loyaltic-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() brandOnly = false;

  isCollapsed = false;
  isLoggedIn = false;
  userId: any;
  currentPage="";
  isOnLandingPage = false;

  constructor(private authService: AuthService, private router: Router) { 
    this.userId = authService.getUserId();
    this.isLoggedIn = authService.IsLoggedIn();

    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentPage = this.router.url;
          this.isOnLandingPage = this.getPath(this.currentPage) === '/';
          this.isCollapsed = false;
          //console.log('this.router.url', this.router.url);
        }
      }
    );
  }

  ngOnInit() {
    this.currentPage = this.router.url;
    this.isOnLandingPage = this.getPath(this.currentPage) === '/';
    //console.log(this.currentPage);

    this.authService.loginEmitter.subscribe((response: boolean) => {
      this.isLoggedIn = response;
    });
  }

  onLogoutClick() {
    this.isLoggedIn = false;
    this.authService.resetTokens();
    this.router.navigate(['/']);
  }

  private getPath(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

}
